if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        let slideToggles = document.querySelectorAll('.product__media-toggle');
        // Clear array of media IDs each time modal is opened
        this.slideMediaIds = [];
        // Loop over available media and store media IDs
        for (let i = 0; i < slideToggles.length; i++) {
          this.slideMediaIds.push(slideToggles[i].dataset.mediaId);
        }
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this, this.prevButton));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this, this.nextButton));
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaCaption = this.querySelector(
          `.productImageCaption[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        if (activeMediaCaption) {
          activeMediaCaption.classList.add('active');
        }
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        // Assign neighbor media id to prev and next buttons
        this.requestedMediaIndex = this.slideMediaIds.indexOf(this.openedBy.getAttribute('data-media-id'));
        // Check for out of bounds calculations - wrap if at bound
        let prevMediaIdIndex =
          this.requestedMediaIndex - 1 == -1 ? this.slideMediaIds.length - 1 : this.requestedMediaIndex - 1;
        let nextMediaIdIndex =
          this.requestedMediaIndex + 1 == this.slideMediaIds.length ? 0 : this.requestedMediaIndex + 1;
        this.prevButton.dataset.mediaId = this.slideMediaIds[prevMediaIdIndex];
        this.nextButton.dataset.mediaId = this.slideMediaIds[nextMediaIdIndex];

        // Desktop hover zoom window calculation
        activeMedia.onmousemove = function (e) {
          e.target.style.setProperty('--x', (100 * e.offsetX) / e.target.offsetWidth + '%');
          e.target.style.setProperty('--y', (100 * e.offsetY) / e.target.offsetHeight + '%');
        };

        // Mobile touch zoom window switch
        activeMedia.ontouchstart = function (e) {
          e.preventDefault();
          activeMedia.classList.add('hover_effect_on');
        };

        // Mobile - touch zoom window calculation on pointerenter to ensure window is focused on where user initially clicked
        activeMedia.onpointerenter = function (e) {
          e.target.style.setProperty('--x', (100 * e.offsetX) / e.target.offsetWidth + '%');
          e.target.style.setProperty('--y', (100 * e.offsetY) / e.target.offsetHeight + '%');
        };

        // Mobile - touch zoom window re-calculation as user moves around
        activeMedia.onpointermove = function (e) {
          e.target.style.setProperty('--x', (100 * e.offsetX) / e.target.offsetWidth + '%');
          e.target.style.setProperty('--y', (100 * e.offsetY) / e.target.offsetHeight + '%');
        };

        // Mobile - remove hover effect when user lifts finger
        activeMedia.onpointerup = function (e) {
          e.preventDefault();
          activeMedia.classList.remove('hover_effect_on');
        };
      }

      onButtonClick(button, event) {
        event.preventDefault();
        this.openedBy = button;
        this.showActiveMedia();
      }
    }
  );
}
